export const breakpoints = {
  // These are the correct breakpoints:
  small: 576,
  medium: 768,
  large: 992,
  xlarge: 1440
};

export const isMobile = (): boolean => {
  return window.innerWidth < breakpoints.medium;
};
export const isMobilelandscape = (): boolean => {
  return (
    window.innerWidth <= breakpoints.large &&
    window.innerWidth >= breakpoints.medium
  );
};
export const isMobileONLY = (): boolean => {
  return window.innerWidth <= breakpoints.medium;
};

// The following functions mimic Bootstrap's "Mobile First" methodology
// So they should be used like how you use bootstrap responsive classes
// each function is a condition that says if it is "this size or bigger"

/*
So for example, if you want to display one component "MobileComponent" when
the screen size is Sm or lower, and other if it is bigger, you will do something like:

if(isMd()) {
  return <DesktopComponent/>;
}
return <MobileComponent/>;
 */

export const isXs = (): boolean => {
  return window.outerWidth >= 0;
};

export const isSm = (): boolean => {
  return window.outerWidth >= breakpoints.small;
};

export const isMd = (): boolean => {
  return window.outerWidth >= breakpoints.medium;
};

export const isLg = (): boolean => {
  return window.outerWidth >= breakpoints.large;
};

export const isXl = (): boolean => {
  return window.outerWidth >= breakpoints.xlarge;
};
